import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';
import MasterTab from 'src/components/Layouts/MasterTab.vue';
import PruningCatch from 'src/views/Pages/Dashboard/Pruning/PruningCatch/PruningCatch.vue';
import PruningCatching from './PruningCatching/PruningCatching.vue';
import PruningMethods from './PruningMethods/Index.vue';
import PruningReasonRejections from 'src/views/Pages/Dashboard/Pruning/PruningReasonRejection/PruningReasonRejections.vue';
import PruningReasons from './PruningReasons/PruningReasons.vue';

const PruningsRoutes = {
  path: 'pruning',
  name: 'Poda',
  component: MasterTab,
  props: { reference: 'pruningTabs' },
  children: [
    {
      path: 'reasons',
      name: 'Poda',
      component: PruningReasons,
      meta: {
        prefix_permission: 'pruning_reasons',
      },
    },
    {
      path: 'catching',
      name: 'Poda',
      component: PruningCatching,
      meta: {
        prefix_permission: 'pruning_catching',
      },
    },
    {
      path: 'methods',
      name: 'Poda',
      component: PruningMethods,
      meta: {
        prefix_permission: 'pruning_methods',
      },
    },
    {
      path: 'pruningreasonrejection',
      name: 'sowing.prunning',
      component: PruningReasonRejections,
      meta: {
        prefix_permission: 'nursery_reasonrejection',
      },
    },
    {
      path: 'pruningcatch',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'sowing.prunning_capture',
          component: PruningCatch,
          meta: {
            prefix_permission: 'pruning_pruningcatch',
          },
        },
      ],
    },
  ],
};

export default PruningsRoutes;
